import { useEffect, useState } from 'react';

export const useStuckState = (buttonRef: HTMLElement | null) => {
  const [stuck, setIsStuck] = useState<boolean>(false);

  useEffect(() => {
    if (!buttonRef) {
      return;
    }
    /**
     * Хендлер, необходимый для удаления фона кнопки, когда она переходит в position:static
     * */
    const stuckObserver = new IntersectionObserver(
      entries =>
        entries.forEach(entry => {
          if (entry.intersectionRatio === 1) {
            setIsStuck(false);
          } else {
            setIsStuck(true);
          }
        }),
      { threshold: 1 },
    );

    stuckObserver.observe(buttonRef as Element);

    return () => {
      stuckObserver.disconnect();
    };
  }, [buttonRef]);

  return { stuck };
};
